import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":5107/consumer/mall/order/cancel";
};

// Cancel Order
export const mallCancelOrder = (id, params) => {
  const url = `${baseURL()}/requestCancel/${id}`;

  return axios.post(url, params);
};

// Withdraw Cancellation
export const mallWithdrawCancellation = id => {
  const url = `${baseURL()}/cancelRequest/${id}`;

  return axios.post(url);
};
